/**
  Belice Semijoias - Cart Gift With Purchase (GWP) Engine
  Gerencia o seletor de brindes, a barra de metas dupla (Frete R$ 250 / Brinde R$ 300),
  identifica automaticamente produtos da coleção 'Brindes' no carrinho e garante
  que exatamente 1 produto dessa coleção fique 100% GRÁTIS ao atingir R$ 300.
 */

(function () {
  const DEFAULT_SHIPPING_THRESHOLD = 25000; // R$ 250,00
  const DEFAULT_GIFT_THRESHOLD = 30000;     // R$ 300,00

  function formatBRL(cents) {
    return (cents / 100).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
  }

  // Coleção de IDs e Handles de Brindes conhecidos
  let giftProductIds = (window.freeGiftConfig && Array.isArray(window.freeGiftConfig.giftProductIds))
    ? window.freeGiftConfig.giftProductIds.map(Number)
    : [];
  let giftVariantIds = (window.freeGiftConfig && Array.isArray(window.freeGiftConfig.giftVariantIds))
    ? window.freeGiftConfig.giftVariantIds.map(Number)
    : [];
  let giftHandles = (window.freeGiftConfig && Array.isArray(window.freeGiftConfig.giftHandles))
    ? window.freeGiftConfig.giftHandles
    : [];

  let isFetchingCollection = false;

  // Carrega catálogo de brindes via API JSON para garantir integridade caso a coleção tenha muitos itens
  async function ensureGiftCollectionData() {
    if (giftProductIds.length > 0 && giftVariantIds.length > 0) return;
    if (isFetchingCollection) return;
    isFetchingCollection = true;

    try {
      const handle = (window.freeGiftConfig && window.freeGiftConfig.collectionHandle) || 'brindes';
      const res = await fetch(`/collections/${handle}/products.json?limit=250`);
      if (!res.ok) return;
      const data = await res.json();
      if (data && Array.isArray(data.products)) {
        data.products.forEach(function (p) {
          if (!giftProductIds.includes(p.id)) giftProductIds.push(p.id);
          if (p.handle && !giftHandles.includes(p.handle)) giftHandles.push(p.handle);
          if (Array.isArray(p.variants)) {
            p.variants.forEach(function (v) {
              if (!giftVariantIds.includes(v.id)) giftVariantIds.push(v.id);
            });
          }
        });

        // Re-executa verificação com os dados completos
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (cart) window.updateGiftAndShippingBars(cart);
          })
          .catch(function () {});
      }
    } catch (e) {
      console.warn('Não foi possível carregar produtos da coleção brindes:', e);
    } finally {
      isFetchingCollection = false;
    }
  }

  // Verifica se um item do carrinho pertence à coleção de brindes
  function isItemInGiftCollection(item) {
    if (!item) return false;
    if (item.properties && (item.properties._is_free_gift === 'true' || item.properties.Brinde)) {
      return true;
    }
    const varId = Number(item.variant_id || item.id);
    const prodId = Number(item.product_id);
    if (giftVariantIds.includes(varId)) return true;
    if (giftProductIds.includes(prodId)) return true;
    if (item.handle && giftHandles.includes(item.handle)) return true;
    return false;
  }

  // Adiciona ou substitui o brinde selecionado no carrinho
  window.selectFreeGift = async function (variantId, buttonEl) {
    if (!variantId) return;

    if (buttonEl) {
      buttonEl.disabled = true;
      buttonEl.classList.add('is-loading');
      buttonEl.textContent = 'Adicionando...';
    }

    try {
      // 1. Obter estado atual do carrinho
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();

      // 2. Verificar se já existe algum brinde explícito no carrinho
      const existingGift = cart.items.find(function (item) {
        return (
          item.properties &&
          (item.properties._is_free_gift === 'true' || item.properties.Brinde)
        );
      });

      // Se já existe e é a MESMA variante, não faz nada
      if (existingGift && existingGift.variant_id === parseInt(variantId, 10)) {
        if (buttonEl) {
          buttonEl.disabled = true;
          buttonEl.classList.remove('is-loading');
          buttonEl.textContent = '✓ Selecionado';
        }
        return;
      }

      // Se já existe outro brinde explícito diferente, remove primeiro
      if (existingGift) {
        const updateBody = { updates: {} };
        updateBody.updates[existingGift.key] = 0;
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(updateBody),
        });
      }

      // 3. Adiciona o brinde com flag e propriedade segura
      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
              properties: {
                _is_free_gift: 'true',
                Brinde: 'Promocional (Grátis)',
              },
            },
          ],
        }),
      });

      if (!addRes.ok) {
        throw new Error('Falha ao adicionar brinde');
      }

      // 4. Atualizar interface do carrinho
      refreshCartUI(variantId);
    } catch (err) {
      console.error('Erro ao escolher brinde:', err);
      alert('Não foi possível adicionar o brinde no momento. Tente novamente.');
      if (buttonEl) {
        buttonEl.disabled = false;
        buttonEl.classList.remove('is-loading');
        buttonEl.textContent = '+ Escolher Brinde';
      }
    }
  };

  // Atualiza gaveta ou página do carrinho
  function refreshCartUI(variantId) {
    if (window.location.pathname.includes('/cart')) {
      setTimeout(function () {
        window.location.reload();
      }, 150);
      return;
    }

    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
      const rootUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url.replace(/\/cart\/?$/, '') : '';
      const fetchUrl = (rootUrl || '') + '/?sections=cart-drawer,cart-icon-bubble';
      fetch(fetchUrl)
        .then(function (res) { return res.json(); })
        .then(function (sections) {
          fetch('/cart.js')
            .then(function (cRes) { return cRes.json(); })
            .then(function (newCart) {
              if (drawer.renderContents) {
                drawer.renderContents({
                  id: variantId,
                  sections: sections,
                  total_price: newCart.total_price,
                });
              } else {
                window.location.reload();
              }
            });
        })
        .catch(function () {
          window.location.reload();
        });
    } else {
      window.location.reload();
    }
  }

  // Atualiza as barras de metas, preços com desconto e o widget de brindes
  window.updateGiftAndShippingBars = function (cartData) {
    let items = [];
    if (cartData && Array.isArray(cartData.items)) {
      items = cartData.items;
    }

    const threshold = (window.freeGiftConfig && window.freeGiftConfig.threshold) || DEFAULT_GIFT_THRESHOLD;

    // Identifica itens do carrinho:
    // 1) Brinde explícito (adicionado pelo botão _is_free_gift)
    // 2) Candidato a brinde (primeiro produto da coleção brindes adicionado)
    let explicitGift = null;
    let candidateGift = null;
    let qualifyingTotal = 0;

    for (let i = 0; i < items.length; i++) {
      const it = items[i];
      const isExplicit = it.properties && (it.properties._is_free_gift === 'true' || it.properties.Brinde);
      const isGiftCol = isItemInGiftCollection(it);

      if (isExplicit && !explicitGift) {
        explicitGift = it;
      } else if (isGiftCol && !candidateGift && !explicitGift) {
        candidateGift = it;
      }
    }

    // O brinde designado para sair 100% GRÁTIS será:
    // o explícito (se existir) OU o primeiro candidato da coleção
    const designatedGiftCandidate = explicitGift || candidateGift;

    // Calcula o valor qualificatório (todos os itens pagos, excluindo 1 unidade do brinde designado)
    items.forEach(function (it) {
      if (designatedGiftCandidate && it.key === designatedGiftCandidate.key) {
        if (it.quantity > 1) {
          const extraQty = it.quantity - 1;
          qualifyingTotal += extraQty * it.price;
        }
      } else {
        qualifyingTotal += it.final_line_price || (it.price * it.quantity);
      }
    });

    const isGiftUnlocked = qualifyingTotal >= threshold;
    const activeFreeGift = isGiftUnlocked ? designatedGiftCandidate : null;
    window.__beliceFreeGiftActive = Boolean(activeFreeGift);

    let alreadyDiscountedOnGift = 0;
    if (activeFreeGift) {
      if (typeof activeFreeGift.line_level_total_discount === 'number' && activeFreeGift.line_level_total_discount > 0) {
        alreadyDiscountedOnGift = activeFreeGift.line_level_total_discount;
      } else if (activeFreeGift.original_line_price && activeFreeGift.final_line_price !== undefined) {
        alreadyDiscountedOnGift = activeFreeGift.original_line_price - activeFreeGift.final_line_price;
      } else if (activeFreeGift.original_price && activeFreeGift.final_price !== undefined) {
        alreadyDiscountedOnGift = activeFreeGift.original_price - activeFreeGift.final_price;
      }
    }

    const hasShopifyDiscount = (cartData.total_discount && cartData.total_discount > 0) || alreadyDiscountedOnGift >= (activeFreeGift ? activeFreeGift.price : 1);
    let effectiveTotal = cartData.total_price || 0;

    // Se o Shopify AINDA NÃO aplicou o desconto nativo, deduz apenas para prévia
    if (activeFreeGift && !hasShopifyDiscount) {
      const remainingDeduction = Math.max(0, activeFreeGift.price - alreadyDiscountedOnGift);
      effectiveTotal = Math.max(0, effectiveTotal - remainingDeduction);
    }

    // Se o brinde não está desbloqueado, o valor dele é somado para exibir o progresso correto
    let displayQualifyingTotal = qualifyingTotal;
    if (!isGiftUnlocked && designatedGiftCandidate) {
      displayQualifyingTotal += designatedGiftCandidate.price;
    }

    // 1. Atualizar Barras de Progresso e Mensagens
    const bars = document.querySelectorAll('.cart-milestone-bar');
    bars.forEach(function (bar) {
      const shippingThreshold = parseInt(bar.dataset.shippingThreshold, 10) || DEFAULT_SHIPPING_THRESHOLD;
      const giftThreshold = parseInt(bar.dataset.giftThreshold, 10) || DEFAULT_GIFT_THRESHOLD;
      const giftEnabled = bar.dataset.giftEnabled !== 'false';

      const maxThreshold = giftEnabled ? giftThreshold : shippingThreshold;
      const percent = Math.min(100, Math.max(0, Math.round((displayQualifyingTotal / maxThreshold) * 100)));
      const isShippingFree = displayQualifyingTotal >= shippingThreshold;

      // Barra de progresso
      const progress = bar.querySelector('.cart-milestone-bar__progress');
      if (progress) {
        const displayPercent = percent < 2 && displayQualifyingTotal > 0 ? 2 : percent;
        progress.style.width = displayPercent + '%';

        progress.classList.remove('is-free', 'is-gift');
        if (isGiftUnlocked) {
          progress.classList.add('is-gift');
        } else if (isShippingFree) {
          progress.classList.add('is-free');
        }
      }

      // Pins
      const pinShipping = bar.querySelector('.pin--shipping');
      if (pinShipping) {
        if (isShippingFree) {
          pinShipping.classList.add('is-achieved');
        } else {
          pinShipping.classList.remove('is-achieved');
        }
      }

      const pinGift = bar.querySelector('.pin--gift');
      if (pinGift) {
        if (isGiftUnlocked) {
          pinGift.classList.add('is-achieved');
        } else {
          pinGift.classList.remove('is-achieved');
        }
      }

      // Mensagem dinâmica
      const message = bar.querySelector('.cart-milestone-bar__message');
      if (message) {
        if (displayQualifyingTotal < shippingThreshold) {
          const diffShipping = shippingThreshold - displayQualifyingTotal;
          message.innerHTML = `🚚 Falta apenas <strong>${formatBRL(diffShipping)}</strong> para <strong>Frete Grátis</strong>!`;
        } else if (displayQualifyingTotal >= shippingThreshold && displayQualifyingTotal < giftThreshold && giftEnabled) {
          const diffGift = giftThreshold - displayQualifyingTotal;
          if (designatedGiftCandidate) {
            message.innerHTML = `🎉 <strong>Frete Grátis!</strong> Falta <strong>${formatBRL(diffGift)}</strong> para seu Brinde sair <strong>100% GRÁTIS</strong>! 🎁`;
          } else {
            message.innerHTML = `🎉 <strong>Frete Grátis garantido!</strong> Falta <strong>${formatBRL(diffGift)}</strong> para ganhar seu <strong>Brinde</strong>! 🎁`;
          }
        } else if (isGiftUnlocked) {
          if (activeFreeGift) {
            message.innerHTML = '🎉 <strong>Parabéns!</strong> Frete Grátis e seu <strong>Brinde Especial</strong> garantidos! 🎁';
          } else {
            message.innerHTML = '🎉 <strong>Parabéns!</strong> Frete Grátis garantido e <strong>Brinde Liberado</strong>! Escolha abaixo: 🎁';
          }
        } else {
          message.innerHTML = '🎉 <strong>Parabéns!</strong> Você ganhou <strong>Frete Grátis</strong>!';
        }
      }
    });

    // 2. Atualizar Totais Estimados no DOM
    const totalValueElements = document.querySelectorAll('.totals__total-value');
    totalValueElements.forEach(function (el) {
      el.textContent = formatBRL(effectiveTotal) + ' BRL';
    });

    // Remove qualquer tag residual de brinde especial das listas de descontos
    const residualGiftDiscounts = document.querySelectorAll('.cart-gift-applied-discount');
    residualGiftDiscounts.forEach(function (item) {
      item.remove();
    });

    // 3. Atualizar estado do widget de brindes (bloqueado / desbloqueado)
    const widgets = document.querySelectorAll('.cart-gift-widget');
    widgets.forEach(function (widget) {
      if (isGiftUnlocked) {
        widget.classList.add('is-unlocked');
        widget.classList.remove('is-locked');
      } else {
        widget.classList.add('is-locked');
        widget.classList.remove('is-unlocked');
      }

      // Atualiza botões nos cards de brindes
      const giftButtons = widget.querySelectorAll('.cart-gift-item__btn');
      giftButtons.forEach(function (btn) {
        const onclickAttr = btn.getAttribute('onclick') || '';
        const match = onclickAttr.match(/selectFreeGift\('?(\d+)'?/);
        const btnVariantId = match ? parseInt(match[1], 10) : null;

        if (activeFreeGift && btnVariantId === activeFreeGift.variant_id) {
          btn.classList.add('is-selected');
          btn.disabled = true;
          btn.textContent = '✓ Selecionado';
        } else if (activeFreeGift) {
          btn.classList.remove('is-selected');
          btn.disabled = false;
          btn.textContent = 'Trocar por este';
        } else {
          btn.classList.remove('is-selected');
          btn.disabled = false;
          btn.textContent = '+ Escolher Brinde';
        }
      });
    });

    // 4. Proteção: se o cliente removeu itens e o total caiu abaixo de R$ 300, remove o brinde explícito
    if (!isGiftUnlocked && explicitGift) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: explicitGift.key, quantity: 0 }),
      }).then(function () {
        refreshCartUI();
      });
    }
  };

  // Mantém retrocompatibilidade com a antiga window.updateShippingBars e aceita cartData ou totalPrice
  window.updateShippingBars = function (cartOrPrice) {
    if (cartOrPrice && typeof cartOrPrice === 'object' && Array.isArray(cartOrPrice.items)) {
      window.updateGiftAndShippingBars(cartOrPrice);
      return;
    }
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (cart) {
          window.updateGiftAndShippingBars(cart);
        }
      })
      .catch(function () {});
  };

  // Disparo inicial ao carregar a página
  document.addEventListener('DOMContentLoaded', function () {
    ensureGiftCollectionData();
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (cart) {
          window.updateGiftAndShippingBars(cart);
        }
      })
      .catch(function () {});
  });

  // Escuta atualizações de carrinho via pubsub do Dawn
  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.cartData) {
        window.updateGiftAndShippingBars(event.cartData);
      } else {
        fetch('/cart.js')
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            if (cart) window.updateGiftAndShippingBars(cart);
          });
      }
    });
  }

  // Escuta cliques no botão de checkout para anexar cupom de desconto se configurado
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('button[name="checkout"], #CartDrawer-Checkout, #checkout');
    if (!btn) return;
    const discountCode = window.freeGiftConfig && window.freeGiftConfig.discountCode;
    if (discountCode && window.__beliceFreeGiftActive) {
      e.preventDefault();
      window.location.href = `/checkout?discount=${encodeURIComponent(discountCode)}`;
    }
  });
})();
